/**
 * Google Analytics (gtag.js) Registration
 * Initializes Google Analytics tracking
 */

import config from "./config";

/**
 * Initialize Google Analytics
 */
export function registerGTM() {
  if (!config.googleAnalyticsId) {
    console.warn("Google Analytics ID not configured");
    return;
  }

  // Create script element for gtag.js
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${config.googleAnalyticsId}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  
  gtag("js", new Date());
  gtag("config", config.googleAnalyticsId);
  
  console.log("✓ Google Analytics initialized");
}

export default registerGTM;

